import Row from '@app/components/layout/Row'
import { Button } from '@app/components/core/button/Button'
import { useTranslations } from '@i18n/useLanguage'

export type FieldEditActionsProps = {
  onCancel: () => void
  /**
   * When omitted, Save is `type="submit"` and the parent `<form>`’s `onSubmit` runs
   * (same pattern as MainInfoEditPanel). When provided, Save is `type="button"`.
   */
  onSave?: () => void
  saveDisabled?: boolean
}

export const FieldEditActions = ({
  onCancel,
  onSave,
  saveDisabled,
}: FieldEditActionsProps) => {
  const t = useTranslations().app.common
  const saveIsSubmit = !onSave

  return (
    <Row gap="0.5rem" style={{ justifyContent: 'flex-end' }}>
      <Button
        type="button"
        variant="secondary"
        size="small"
        label={t.cancel}
        onClick={onCancel}
      />
      <Button
        type={saveIsSubmit ? 'submit' : 'button'}
        variant="primary"
        size="small"
        label={t.save}
        disabled={saveDisabled ?? false}
        onClick={saveIsSubmit ? undefined : onSave}
      />
    </Row>
  )
}
